export default __webpack_public_path__ + "static/media/make-vin-change-history.e1d6a774.png";